import { render, staticRenderFns } from "./ProductsListContainer.vue?vue&type=template&id=d32909f4&scoped=true&"
import script from "./ProductsListContainer.vue?vue&type=script&lang=js&"
export * from "./ProductsListContainer.vue?vue&type=script&lang=js&"
import style0 from "./ProductsListContainer.vue?vue&type=style&index=0&id=d32909f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d32909f4",
  null
  
)

export default component.exports